import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { configApi } from "@/lib/admin-api/config";

// ---------------------------------------------------------------------------
// Query keys
// ---------------------------------------------------------------------------

const KEYS = {
  config: ["admin-config"] as const,
} as const;

// ---------------------------------------------------------------------------
// Queries
// ---------------------------------------------------------------------------

export function useConfig() {
  return useQuery({
    queryKey: KEYS.config,
    queryFn: () => configApi.get(),
    staleTime: 60_000,
  });
}

// ---------------------------------------------------------------------------
// Mutations
// ---------------------------------------------------------------------------

export function useUpdateConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof configApi.update>[0]) =>
      configApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.config });
      toast.success("Configuration sauvegardée", {
        description: "Les paramètres ont été mis à jour avec succès.",
      });
    },
    onError: (err: Error) => {
      toast.error("Erreur lors de la sauvegarde", {
        description: err.message ?? "Une erreur est survenue.",
      });
    },
  });
}
